export default "__VITE_ASSET__CJB3FvNI__"